import { RouterPage } from 'lib/navigation/consts'

interface Params {
  warning?: Maybe<string>
  error?: Maybe<string>
  next?: Maybe<string>
}

/**
 * Returns path to the login page with optional redirect path.
 */
export const getLoginPath = ({ warning, next, error }: Params = {}) => {
  const path = RouterPage.login
  const searchParams = new URLSearchParams()

  if (next) {
    searchParams.set('next', next)
  }
  if (warning) {
    searchParams.set('warning', warning)
  }
  if (error) {
    searchParams.set('error', error)
  }

  return searchParams.toString() ? `${path}?${searchParams.toString()}` : path
}
